import { render } from "./auto-swap.vue?vue&type=template&id=6a11dff9"
import script from "./auto-swap.vue?vue&type=script&lang=js"
export * from "./auto-swap.vue?vue&type=script&lang=js"

import "./auto-swap.vue?vue&type=style&index=0&id=6a11dff9&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__